import React, { Component } from "react";
import { connect } from "react-redux";
import {
	Button,
	Modal,
	ModalBody,
	ModalHeader,
	ModalFooter,
	Input
} from "reactstrap";
import { downloadPPT } from "../../actions/planoCampaignActions";

class DownloadPPTComponent extends Component {
	state = {
		isOpen: false,
		selectedSharingUserValues: [],
        emails: ""
	};


	handleToggleButton = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	handleDownloadPPTButton = () => {
        const { downloadPPT, campaign_id } = this.props;
        const { emails } = this.state;
        downloadPPT(campaign_id, emails);
        this.handleToggleButton();
    };

	handleEmailChangeListener = e => {
        this.setState({ emails: e.target.value });
	};

	render() {
        const { isOpen, emails } = this.state;

		return (
			<div>
                <Button color="success" onClick={this.handleToggleButton}>
					Download PPT
				</Button>
				<Modal isOpen={isOpen} toggle={this.handleToggleButton}>
					<ModalHeader>
						Download Plan PPT (PPT will be sent to email)
					</ModalHeader>
					<ModalBody>
						<Input
							placeholder="Enter Email Id (Comma Seperated)"
                            value={emails}
							onChange={this.handleEmailChangeListener.bind(this)}
						/>
					</ModalBody>
					<ModalFooter>
						<Button
							onClick={this.handleDownloadPPTButton.bind(this)}
							color="success"
						>
							Download PPT
						</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

export default connect(
	mapStateToProps,
    { downloadPPT }
)(DownloadPPTComponent);



// WEBPACK FOOTER //
// ./src/v3/components/campaign/downloadPPT.js